import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const FolderAPI = {
  getAll: function ({ org_id, ...params }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/folders`,
      params: params,
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getFavoriteFolders: function ({ org_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/favourite-folders`,
    })
  },
  search: function ({ org_id, ...params }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/folders`,
      params: params,
      cancelToken: cancelTokenObject[this.search.name].requestCancellation().token,
    })
  },
  getById: function (org_id, folder_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/folders/${org_id}/${folder_id}`,
    })
  },
  create: function ({ org_id, name, submission_type }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/folders`,
      data: { name, submission_type },
    })
  },
  update: function ({ org_id, folder_id, ...data }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/folders/${org_id}/${folder_id}`,
      data: data,
      cancelToken: cancelTokenObject[this.update.name].requestCancellation().token,
    })
  },
  delete: function ({ org_id, folder_id }) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/folders/${org_id}/${folder_id}`,
    })
  },
  assign: function ({ org_id, folder_id, user_ids }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/folders/${org_id}/${folder_id}/assign`,
      data: { users: user_ids },
    })
  },
  getDocumentTemplates: function ({ org_id, folder_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/document-templates/${org_id}/${folder_id}`,
    })
  },
  updateServiceLabel: function ({ org_id, folder_id, template_id, label_id, display_name, data_type, enable }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/service-labels/${org_id}/${folder_id}/${template_id}/${label_id}`,
      data: { display_name, data_type, enable },
    })
  },
  updateSubmissionField: function ({ org_id, folder_id, field_id, ...data }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/folders/${org_id}/${folder_id}/submission-fields/${field_id}`,
      data: data,
    })
  },
  createSubmissionField: function ({ org_id, folder_id, ...data }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/folders/${org_id}/${folder_id}/submission-fields`,
      data: data,
    })
  },
  deleteSubmissionField: function ({ org_id, folder_id, field_id }) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/folders/${org_id}/${folder_id}/submission-fields/${field_id}`,
    })
  },
  sortLabels: function ({ org_id, folder_id, template_id, label_ids }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/document-templates/${org_id}/${folder_id}/${template_id}/sort-labels`,
      data: { label_ids },
    })
  },
  sortFields: function ({ org_id, folder_id, label_ids }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/folders/${org_id}/${folder_id}/sort-labels`,
      data: { label_ids },
    })
  },
}

const cancelTokenObject = createCancelToken(FolderAPI)
export default FolderAPI
